import Page from '../../components/layouts/page'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@cinesend/ui-kit'
import { ListBullets } from '@phosphor-icons/react'
import useStore from '../../hooks/use_store'
import { useState } from 'react'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import CreateForm from '../metadata/create_form'
import GroupsPoolsTable from '../../components/groups_pools_table'
import { useQuery } from '@tanstack/react-query'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../../components/disabled_tooltip'

const PAGE = {
  'ad-pools': { title: 'Ad Sets', create: 'Create Ad Set', path: 'ad-sets' },
  'warning-slates': { title: 'Slate Sets', create: 'Create Slate Set', path: 'slate-sets' },
}

const GroupsPools = ({ categoryType }) => {
  const params = useParams()
  const navigate = useNavigate()
  const { createModel } = useStore()
  const [showCreateModal, setShowCreateModal] = useState(false)
  const queryKey = `/categories?cycleID=${params.cycleID}`
  const { canEditModel: canEditCategory } = useAuth(modelTypes.Category, { is_root: false })
  const { data: cycle } = useQuery(['cycles/', params.cycleID])
  const page = PAGE[categoryType]

  return (
    <Page
      title={page.title}
      breadcrumbs={[{ text: page.title }]}
      buttons={
        canEditCategory
          ? [
              <DisabledTooltip key='create' reason={cycle?.is_locked ? DISABLED_REASONS.cycleClosed : null}>
                <Button
                  leadingIcon={<ListBullets size={20} />}
                  disabled={!!cycle?.is_locked}
                  onClick={() => setShowCreateModal(true)}
                >
                  {page.create}
                </Button>
              </DisabledTooltip>,
            ]
          : []
      }
    >
      <GroupsPoolsTable queryKey={queryKey} categoryType={categoryType} />
      {showCreateModal && (
        <CreateForm
          onClose={() => setShowCreateModal(false)}
          cycleID={params.cycleID}
          createModel={createModel}
          categoryType={categoryType}
          onSuccess={(res) =>
            navigate(
              `/airlines/${params.airlineID}/cycles/${params.cycleID}/ads/${page.path}/${res.data.category.id}/details`
            )
          }
        />
      )}
    </Page>
  )
}

export default GroupsPools
